import styled from 'styled-components';
import { bodySmall, poppinsRegularFont } from '@/styles/typography';
import { COLORS } from '@/styles/colors';
import { resetButton } from '@/styles/common';

export const CookiePreferencesButton = styled.button`
  ${poppinsRegularFont};
  color: ${COLORS.green[500]};
  ${resetButton};
  ${bodySmall};
  cursor: pointer;
`;
